import {createAction} from 'redux-actions';

const asyncActionsMiddleware = store => next => action => {
  const isAsync = action.hasOwnProperty('meta') && action.meta.async;

  if (!isAsync) {
    return next(action);
  } else {
    const { httpMethod } = action.meta;
    const inProgressAction = generateInProgressAction(action.type);

    Promise.resolve(1).then(() => { store.dispatch(inProgressAction()); });

    httpMethod(action.payload)
      .then(res => {
        let func;

        if (res.isOkay) {
          const successAction = generateSuccessAction(action.type);

          func = () => store.dispatch(successAction(res.data));
        } else {
          const failureAction = generateFailureAction(action.type);

          func = () => store.dispatch(failureAction(res.errors));
        }

        Promise.resolve(1).then(func);
      })
      .catch(err => {
        Promise.resolve(1).then(() => store.dispatch(generateFailureAction(action.type)(err.errors)));
      });

    return next(action);
  }
};

const generateInProgressAction = type => createAction(`${type}_IN_PROGRESS`);
const generateSuccessAction = type => createAction(`${type}_SUCCESS`);
const generateFailureAction = type => createAction(`${type}_FAILURE`);

export {
  asyncActionsMiddleware,
  generateInProgressAction,
  generateSuccessAction,
  generateFailureAction
};

export default asyncActionsMiddleware;


// WEBPACK FOOTER //
// ./src/components/utils/middleware/AsyncActions.js